import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ErrorComponent from '../components/Error/NewError';
import {clearError} from '../actions/Error';
import Scroll from 'react-scroll';
const scroll = Scroll.animateScroll;

class Error extends Component {

    componentDidUpdate() {
        if(this.props.error.hasError === true) {
            scroll.scrollToTop();
        }
    }
    onCloseButtonClick = () => this.props.clearError();

    render() {
        return(
            <ErrorComponent
                error={this.props.error}
                onCloseButtonClick= {this.onCloseButtonClick} />
        );
    }
}

Error.propTypes = {
    error: PropTypes.shape({
        title: PropTypes.string,
        message: PropTypes.string,
        hasError: PropTypes.bool
    }),
    clearError: PropTypes.func
};

const mapStateToProps = (state) => {
   return{
       error:state.error
   };
};
   
const mapDispatchToProps = (dispatch) => {
   return {
   clearError: () => dispatch(clearError()),
   };
};

export default connect(mapStateToProps, mapDispatchToProps)(Error);


// WEBPACK FOOTER //
// ./src/containers/Error.js